export const iconFontAwesomeHolidaysMenorah = (
	<i className="fa-solid fa-menorah"></i>
);
